var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroundConnection01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.68,
    y: 1.43,
    className: "st2",
    width: 0.5,
    height: 9.67
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.16,
    y: 10.85,
    className: "st2",
    width: 5.68,
    height: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.65,12.56l4.56,0c-0.1,1.12-1.09,1.95-2.21,1.86C6.85,14.51,5.83,13.7,5.65,12.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.17,14.68c-0.06,0-0.12,0-0.19-0.01c-1.25,0.1-2.38-0.82-2.58-2.07l-0.04-0.29h5.13l-0.02,0.27 C10.35,13.78,9.34,14.68,8.17,14.68z M7.98,14.18c0.93,0.08,1.73-0.52,1.94-1.36H5.96C6.24,13.66,7.06,14.25,7.98,14.18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundConnection01);
export default __webpack_public_path__ + "static/media/GroundConnection-01.d5f627f34a1bdc8fb3b0d051024bb8b5.svg";
export { ForwardRef as ReactComponent };